import CattleSummaries from './CattleSummaries'
export default CattleSummaries
